export class InterfaceElementDefaults{
  public static readonly InputPicklistDefault = "00000000-0000-0000-0000-000000000000";
}
